import { KYMW1708Component } from "./kymw1708.component";

export class KYMW1708Model {
  kymw1708Component: KYMW1708Component;
  
  /** 画像ファイル名 */
  imageFileName: string = <string>'';
  /** プレビュー画像URL */
  imagePreviewUrl: string = <string>'';
  /** 画像ID */
  imageId: string = < string>''
  /** 呼出元画像ID */
  callerImageId: string = <string>'';
}